import { Dialog } from '@mui/material';
import styles from './PaymentLink.module.css';
import CloseIcon from '@mui/icons-material/Close';
import lockIcon from '../../../../../assets/images/lock-border.svg';

const PaymentLinkDialog = (props: any) => {
	const { cancelButtonClick, data, open } = props;

	return (
		<Dialog
			open={open}
			sx={{
				zIndex: '99999',
				minWidth: '490px',

				'& .MuiDialog-paper': {
					width: '100%',
					maxWidth: '500px',
					maxHeight: '500px',
					minHeight: '200px',
					padding: '0px',
					borderRadius: '8px',
					boxShadow:
						'0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)',
					/* 	left: '10%', */
					background: '#FFFFFF',
					overflow: 'hidden',
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
				},
			}}>
			<div>
				<div className={styles.addOnPopupHead}>
					<div className={styles.addOnPopupTitle}>
						<img src={lockIcon} alt='icon' />
					</div>
					<div className={styles.closeModalButton}>
						<CloseIcon
							sx={{ color: '#555555', cursor: 'pointer' }}
							onClick={cancelButtonClick}
						/>
					</div>
				</div>
				<div className={styles.payLinkBody}>
					<div className={styles.payLinkTitle}>Payment Link Generated</div>
					<div className={styles.payLinkSubTitle}>Verification Link</div>
					<a
						style={{
							wordBreak: 'break-all',
							whiteSpace: 'normal',
							overflowWrap: 'break-word',
						}}
						className={styles.payLink}
						href={data?.data}
						target='_blank'
						rel='noopener noreferrer'>
						{data?.data}
					</a>

					<div className={styles.payLinkResend}>
						{/* Didn’t get a Link? */}
						{/* 		<button>Click to resend.</button> */}
					</div>
				</div>

				{/* 	<div className={styles.addOnBtnSplit}>
				<CancelBtn onClick={cancelButtonClick} />
				<SaveBtn buttonText='Confirm' />
			</div> */}
			</div>
		</Dialog>
	);
};
export default PaymentLinkDialog;
